import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export function thesaurusRoutes($stateProvider: StateProvider) {
    let thesaurusModule: { default: any; };
    $stateProvider
        .state({
            name: 'thesaurus',
            url: '/thesaurus',
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => thesaurusModule.default,
            },
            lazyLoad: async () => {
                thesaurusModule = await import(/* webpackChunkName: "thesaurus" */ './KpThesaurusPage.svelte');
                return null;
            }
        });
}